import React, { Component } from "react";

class AdrAmendmentAnnotationsV3 extends Component {
  render() {
    const { annotation } = this.props;
    return (
      <div className="alert alert-light p-2 mt-2 mb-0">
        <span>
          <b>Amendment Remarks/Annotations:</b>
        </span>
        <br />
        <p className="mb-0">{annotation}</p>
      </div>
    );
  }
}

export default AdrAmendmentAnnotationsV3;
